/** Date utilities working on 'YYYY-MM-DD' strings in local time. */
export function todayISO(): string {
  return toISODate(new Date());
}

export function toISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function addDays(iso: string, days: number): string {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + days);
  return toISODate(d);
}

/** Whole days from today to `iso` (negative when in the past). */
export function daysUntil(iso: string | null | undefined, from: string = todayISO()): number | null {
  if (!iso) return null;
  const a = new Date(`${from}T00:00:00`).getTime();
  const b = new Date(`${iso}T00:00:00`).getTime();
  return Math.round((b - a) / 86_400_000);
}

export function monthKey(iso: string): string {
  return iso.slice(0, 7);
}

/** Consecutive month keys, e.g. lastNMonths(3, '2026-10') → ['2026-08','2026-09','2026-10'] */
export function monthRange(startKey: string, count: number): string[] {
  const [y, m] = startKey.split('-').map(Number);
  return Array.from({ length: count }, (_, i) => {
    const d = new Date(y, m - 1 + i, 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  });
}
